import NavigationSection from "../navigation-section";

// re-order separators to always be 1-2-3

// const debug = false
const debug = "navigation_addSection"

export default function navigation_addSection(section: NavigationSection | null, groupNumber:number, isFirst:boolean = false) {

    debug && console.log(debug, 'process', groupNumber, isFirst, section)

    const navigationStructure = gd.layout.navigation.navigationStructure

    navigationStructure.debug()

    if (groupNumber==1 && isFirst && !!section) {

        navigationStructure.addAtPosition(section, 0)

        // navigationStructure.sort()
        // navigationStructure.regenerateSortPositions()
        // navigationStructure.sort()
        // navigationStructure.saveSortPositions()
    }

    if (groupNumber==1 && !isFirst && !!section) {
        // const separator1  = navigationStructure.get('separator-g1')
        // navigationStructure.addBefore(section, separator1)
        navigationStructure.add(section)
    }

    if (groupNumber==3 && !isFirst && !!section) {
        // const separator3  = navigationStructure.get('separator-g3')
        // navigationStructure.addBefore(section, separator3)

        navigationStructure.add(section)
    }

    if (groupNumber==4 && !isFirst) {
        navigationStructure.add(section) // last one
    }

    navigationStructure.regenerateSortPositions()
    navigationStructure.sort()
    navigationStructure.debug()
    navigationStructure.saveSortPositions()
    navigationStructure.savePositions() // save to gd.user.settings.navigation.buttonPositions

    // apply app specific navigation behaviour
    const app: any = gd.getMainApp()
    if (app?.updateMainNavigation) app.updateMainNavigation()

    gd.layout.navigation.reRender("CustomView on add to panel")
    gd.layout.currentMenu?.reRender()


}
